export const TOUR_THEME_CLASS = "shepherd-mixfiscal";

export const TOUR_OPTIONS = {
  useModalOverlay: true, // escurece a tela e recorta (spotlight) o elemento
  defaultStepOptions: {
    scrollTo: { behavior: "smooth", block: "center" },
    cancelIcon: { enabled: true },
    classes: TOUR_THEME_CLASS,
    // folga ao redor do elemento destacado — evita cortar o texto do topo.
    modalOverlayOpeningPadding: 8,
    modalOverlayOpeningRadius: 6,
  },
};

export const TOUR_LABEL_PADRAO = "Como usar";
export const TOUR_TOOLTIP_PADRAO =
  "Novo por aqui? Faça um tour guiado, passo a passo.";
export const TOUR_MENU_TITULO_PADRAO = "Como usar";
export const TOUR_TROCAR_TOPICO = "Ir direto para";
export const TOUR_TOUR_GUIADO = "▶ Tour guiado (passo a passo)";

export const TOUR_BOTOES = {
  voltar: "Voltar",
  proximo: "Próximo",
  concluir: "Concluir",
};
